<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <section class="widget-section q-mb-lg">
      <EnvRegistration :registrationId="registrationId" :registrationData="registrationData" :envs="envs" mode="edit" />
    </section>
    <section v-if="registrationData.infrastructureServiceApm === 'IAASSC'" class="widget-section q-mb-lg">
      <h5 class="q-mb-sm q-mt-none text-weight-bold" style="font-size: 20px">ESC Onboarding</h5>
      <p class="q-mb-none">
        Not yet integrated in Engineering Portal. Please use
        <a target="_blank" :href="snowLink">ContactOne Catalogue Item</a>
        to onboard your APM.
      </p>
    </section>
  </q-page>
</template>

<script>
import EnvRegistration from './EnvRegistration.vue';

export default {
  name: 'Registration2Env',
  components: {
    EnvRegistration,
  },
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
  },
  data() {
    return {
      envs: ['PROD', 'NONPROD'],
    };
  },
  computed: {
    snowLink() {
      return `${process.env.VUE_APP_SNOW_URL}/contactone?id=sc_cat_item&sys_id=ae51e7716f1a5a0015d355ff8d3ee428&sysparm_category=6803f9266fb20600cde14c992e3ee4b6`;
    },
  },
};
</script>
